import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filter, Subscription, switchMap, tap, distinctUntilChanged, startWith } from 'rxjs';
import { AppStateService } from '../../../../shared/services/app-state.service';
import { AdminClinicService } from '../../../../components/clinics/services/admin-clinic.service';
import { loadStripe, Stripe, StripeElements, StripeElementsOptions } from '@stripe/stripe-js';

@Component({
  selector: 'app-scc-payment-method-input',
  templateUrl: './scc-payment-method-input.component.html',
  styleUrls: ['./scc-payment-method-input.component.scss']
})
export class SccPaymentMethodInputComponent implements OnInit {
  private static count = 1;

  @Input() returnUrl = window.location.origin;

  @Output() ready = new EventEmitter();

  paymentIntentSecret?: string;
  idElement = `payment-element-${SccPaymentMethodInputComponent.count++}`;

  private stripe?: Stripe;
  private element?: StripeElements;
  private readonly subscription = new Subscription();

  constructor(private readonly appStateService: AppStateService, private readonly adminClinicService: AdminClinicService) {
  }

  ngOnInit() {
    this.subscription.add(
      this.appStateService.clinicIdObservable.pipe(
        startWith(this.appStateService.clinicId),
        distinctUntilChanged(),
        filter(clinicId => clinicId !== undefined && clinicId > 0),
        switchMap(clinicId => this.adminClinicService.getStripeClientSecretForClinicPaymentMethod(clinicId!))
      ).subscribe({
        next: clientSecret => {
          this.paymentIntentSecret = clientSecret.clientSecret;
          loadStripe(clientSecret.publishableKey).then(stripe => {
            if (!stripe) {
              console.error('error while loading stripe');
              return;
            }

            this.stripe = stripe;
            this.initElement();
          }).catch(error => {
            console.error('Error while loading stripe:', error);
          });
        },
        error: error => {
          console.error('Error while getting stripe client secret:', error);
        }
      })
    );
  }

  save(): void {
    if (!this.element || !this.returnUrl) {
      return;
    }

    this.stripe?.confirmSetup({
      elements: this.element,
      confirmParams: {
        return_url: this.returnUrl
      }
    })?.catch(error => {
      if (error) {
        alert(error);
        console.error(error);
      }
    });
  }

  private initElement() {
    if (!this.paymentIntentSecret) {
      throw new Error('No payment intent secret !');
    }

    const options: StripeElementsOptions = {
      clientSecret: this.paymentIntentSecret,
      appearance: {
        theme: 'stripe',
        variables: {
          fontFamily: 'PT Sans, system-ui, sans-serif',
          fontWeightNormal: '400',
          borderRadius: '3px',
          colorBackground: '#fff',
          colorPrimary: '#c6985f',
          colorPrimaryText: '#1A1B25',
          colorText: '#000',
          colorTextSecondary: '#000',
          colorTextPlaceholder: '#727F96',
          colorIconTab: '#000',
          colorLogo: 'dark'
        }
      }
    };

    this.element = this.stripe?.elements(options);
    const paymentElement = this.element?.create('payment');
    paymentElement?.mount(`#${this.idElement}`);

    setTimeout(() => {
      this.ready.emit(true);
    }, 2000); // Le temps que le formulaire stripe se charge
  }
}
